import { Radio, RadioGroupProps } from 'antd';
import styled from 'styled-components';
import { radioButtonPaddingInline } from '@atlas-frontend/design-tokens';

export const ButtonGroupRadio = ({
  options,
  ...radioGroupProps
}: RadioGroupProps) => (
  <StyledRadioGroup {...radioGroupProps}>
    {options?.map((option) => {
      const { value, label, disabled } =
        typeof option === 'object'
          ? option
          : { value: option, label: option, disabled: false };

      return (
        <StyledRadioButton
          key={String(value)}
          value={value}
          disabled={disabled}
        >
          <ButtonContent>{label}</ButtonContent>
        </StyledRadioButton>
      );
    })}
  </StyledRadioGroup>
);

const StyledRadioGroup = styled(Radio.Group)`
  white-space: nowrap;
`;

const StyledRadioButton = styled(Radio.Button)`
  padding: 0 !important;
  span {
    width: 100%;
    display: block;
  }
`;

const ButtonContent = styled.span`
  width: 100%;
  display: block;
  padding-left: ${radioButtonPaddingInline}px;
  padding-right: ${radioButtonPaddingInline}px;
`;
